import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/InvestorFee`;

class InvestorFeeService {
  getAllInvestors() {
    return axios
      .get(`${API_URL}/All`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getInvestor(investorId) {
    return axios
      .get(`${API_URL}/All/InvestorId/${investorId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  createFee(jnl) {
    return axios
      .post(`${API_URL}`, jnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateFee(jnlId, updateJnl) {
    return axios
      .put(`${API_URL}/${jnlId}`, updateJnl, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  deleteFee(jnlId) {
    return axios
      .delete(`${API_URL}/${jnlId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new InvestorFeeService();
